import { classify } from 'sidecar-utilities'

// All styles copied from ../Combobox/styles.ts to make ComboboxControlled self-contained

export const containerStyle = classify({
  position: 'relative w-full',
  group: 'group/combobox',
})

export const labelStyle = ({
  condensed = false,
  disabled = false,
  hasError,
  hasIcon,
  hasValues = false,
}) => {
  if (condensed && hasValues) {
    return 'hidden'
  }
  let textColor = 'color-textPrimary'
  if (disabled) {
    textColor = 'color-text-disabled'
  } else if (hasError) {
    textColor = 'color-textRisk'
  }
  return classify({
    width: 'min-w-fit',
    position: 'absolute',
    withValue: hasValues
      ? 'text-xs top-3'
      : // top-1/2 will align the top of the label to the middle (too low),
        // then the translate will push it back up exactly half of the
        // combobox's height (vertically centered).
        'top-1/2 -translate-y-1/2',
    leftPadding: !hasIcon ? 'left-4' : condensed ? 'left-10' : 'left-13',
    nonClickable: 'pointer-events-none',
    overflow: 'overflow-hidden',
    color: textColor,
    animation: 'transition-all',
    disabled: 'group-disabled/select:color-text-disabled',
    invalid: 'group-invalid/select:color-textRisk-default',
    focus: condensed
      ? 'peer-focus:hidden'
      : 'peer-focus:text-xs peer-focus:top-3 peer-focus:color-textPrimary peer-focus:translate-y-0',
  })
}

export const sublabelStyle = ({ condensed = false, hasIcon }) =>
  classify({
    size: 'sh-body-xs truncate',
    position: 'absolute right-0',
    topPadding: condensed ? 'top-6' : 'top-9',
    leftPadding: !hasIcon ? 'left-4' : condensed ? 'left-10' : 'left-13',
    nonClickable: 'pointer-events-none',
  })

export const comboBoxStyle = ({
  condensed = false,
  hasError = false,
  hasIcon = false,
  hasValues = false,
  showSelectedSublabel = false,
}) => {
  let yPadding
  if (condensed) {
    yPadding = 'py-3'
  } else {
    if (showSelectedSublabel && hasValues) {
      yPadding = 'pt-3 pb-7'
    } else {
      yPadding = 'pt-7 pb-3'
    }
  }

  return classify({
    peer: 'peer',
    width: 'w-full',
    leftPadding: !hasIcon ? 'pl-4' : condensed ? 'pl-10' : 'pl-13',
    // makes room for cancel button
    rightPadding: hasValues ? 'pr-10' : 'pr-4',
    yPadding: yPadding,
    height: condensed ? 'h-12' : 'h-16',
    border: 'rounded-lg border color-border-default',
    hover: 'hover:color-border-hover',
    active: 'active:color-border-active',
    focus:
      'focus:color-border-active focus:outline focus:outline-4 focus:color-outlinePrimaryDecor',
    disabled: 'disabled:color-textOnDefaultWeak disabled:color-border-disabled',
    error: hasError ? 'color-borderRisk-default' : '',
    color: 'color-bgDefault color-textOnDefault',
    placeholder:
      'placeholder:text-transparent focus:placeholder:color-text-disabled',
  })
}

export const leftMediaStyle = classify({
  // selectorForSearchField is so the SearchField can style the leftMedia without needing an extra prop on the combobox
  selectorForSearchField: 'leftMedia',
  position: 'absolute left-4 top-1/2 -translate-y-1/2',
})

export const busyIconStyle = condensed => {
  return classify({
    color: 'color-icon-default',
    animation: 'animate-spin',
    position: 'absolute right-4',
    // 50% will align the top of the icon to the middle (too low),
    // then the -theme(space.2) will push it back up
    // exactly half of the combobox's height (vertically centered).
    middleAlign: condensed
      ? 'top-[calc(50%-theme(space.2))]'
      : 'top-[calc(50%-theme(space.3))]',
  })
}

export const cancelBtnStyle = classify({
  // selectorForSearchField is so the SearchField can style the cancelBtn without needing an extra prop on the combobox
  selectorForSearchField: 'cancelBtn',
  position: '!absolute right-4',
  // 50% will align the top of the icon to the middle (too low),
  // then the -theme(space.2) will push it back up
  // exactly half of the combobox's height (vertically centered).
  middleAlign: 'top-[calc(50%-theme(space.2))]',
})
